import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReusableTabs from 'components/commom/Tab';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getPracticeList } from 'store/getPracticeList/getPracticesListAction';
import EditPractice from 'assets/images/Dashboard/edit-practice.svg';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import { getSubPracticeList } from 'store/getSubPracticeList/getSubPracticeListAction';
import { practicesDetail } from 'routes/AppUrls';
import DeleteList from 'assets/images/Dashboard/delete.svg';
import { deletePracticeData } from 'store/practiceDetelet/practiceDeleteAction';
import {
  basicDetailsValue,
  PRACTICE_DETAIL_ID,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonModal from 'components/commom/Modal';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import SelectInput from 'components/commom/SelectInput';
import { getPracticeSubList } from 'store/practiceList/practiceListAction';
import { getSubPracticeDetail } from 'store/getSubPracticeDetail/getSubPracticeDetailAction';
import ReusableButton from 'components/commom/Button';
import { createSubPractice } from 'store/createSubPractice/createSubPracticeAction';
import { updateSubPractice } from 'store/updateSubPractice/updateSubPracticeAction';
import { deleteSubPracticeData } from 'store/subPracticeDelete/subPracticeDeleteAction';
import CheckValidation from 'utils/validate';
import CommonToast from 'components/commom/CommonToast';

const PracticeList = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
  const [practiceList, setPracticeList] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [SubPracticeModal, setSubPracticeModal] = useState(false);
  const [deleteSubModal, setDeleteSubModal] = useState(false);
  const [isError, setIsError] = useState(false);
  const [subPracticesList, setSubPracticesList] = useState([]);
  const [formValue, setformValue] = useState({
    sub_practice_name: '',
  });
  const [editIndex, setEditIndex] = useState(null);
  const [subPracticeId, setSubPraticeId] = useState('');

  const loading = useSelector(
    (state) => state?.getPracticeListReducer?.loading
  );

  const loadingSub = useSelector(
    (state) => state?.getSubPracticeListReducer?.loading
  );

  const providerData = useSelector(
    (state) => state?.getPracticeReducer?.users?.data
  );

  const createReducer = useSelector(
    (state) => state?.createSubPracticeReducer?.loading
  );

  const updateReducer = useSelector(
    (state) => state?.updateSubPracticeReducer?.loading
  );

  const deletePracticeLoading = useSelector(
    (state) => state?.deletePracticeListReducer?.loading
  );

  const deleteSubPracticeLoading = useSelector(
    (state) => state?.deleteSubPracticeListReducer?.loading
  );

  const tabData = [
    { label: intl.formatMessage({ id: 'Practice' }) },
    { label: intl.formatMessage({ id: 'Sub-practice' }) },
  ];

  useEffect(() => {
    setFormData(providerData?.[0]);
    setPracticeId(providerData?.[0]?.id);
  }, [providerData]);

  const [formData, setFormData] = useState(providerData?.[0]);
  const [practiceId, setPracticeId] = useState(providerData?.[0]?.id ?? '');

  const handleTabChange = (val) => {
    setTab(val);
  };

  useEffect(() => {
    if (tab === 1) {
      getPracticeListValue();
    } else {
      getSubPracticeListValue();
      getPractice();
    }
  }, [tab]);

  const getPracticeListValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setPracticeList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getPracticeList(external));
  };

  const handlePracticeDetail = (id) => {
    navigate(practicesDetail(locale));
    if (id) {
      dispatch(basicDetailsValue(PRACTICE_DETAIL_ID, id));
    } else {
      dispatch(basicDetailsValue(PRACTICE_DETAIL_ID, ''));
    }
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteId('');
  };

  const deletePracticeList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseDeleteModal();
        getPracticeListValue();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deletePracticeData(external, deleteId));
  };

  const getSubPracticeListValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSubPracticesList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSubPracticeList(external));
  };

  const handleSubPracticeModal = (id, index = null) => {
    setSubPracticeModal(true);
    if (id) {
      getSubPractceDetail(id);
      setEditIndex(index);
      setSubPraticeId(id);
    }
  };

  const getSubPractceDetail = (id) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleSuccess(res);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSubPracticeDetail(external, id));
  };

  const handleSuccess = (res) => {
    setformValue((prev) => ({
      ...prev,
      sub_practice_name: res?.data?.name,
    }));
    setFormData(res?.data?.practice);
  };

  const getPractice = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getPracticeSubList(external));
  };

  const handleChange = (event) => {
    setFormData(event?.target?.value);
    setPracticeId(event?.target?.value?.id);
  };

  const handleCloseSubPracticeModal = () => {
    setSubPracticeModal(false);
    setformValue('');
    setFormData(providerData?.[0]);
    setPracticeId(providerData?.[0]?.id);
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubPractice = () => {
    if (editIndex !== null) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          handleCloseSubPracticeModal();
          getSubPracticeListValue();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      if (error.submit) {
        let body = {
          name: formValue?.sub_practice_name,
        };
        dispatch(updateSubPractice(external, body, subPracticeId));
      }
    } else {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          handleCloseSubPracticeModal();
          getSubPracticeListValue();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      if (error.submit) {
        let body = {
          name: formValue?.sub_practice_name,
        };
        dispatch(createSubPractice(external, body));
      }
    }
  };

  const handleDeleteSubModal = (id) => {
    setDeleteSubModal(true);
    setDeleteId(id);
  };

  const handleCloseSubDeleteModal = () => {
    setDeleteSubModal(false);
    setDeleteId('');
  };

  const deleteSubPracticeList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseSubDeleteModal();
        getSubPracticeListValue();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deleteSubPracticeData(external, deleteId));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0 pb-16">
            <FormattedMessage id="Practices" />
          </h2>
          <Row>
            <Col md={6} lg={5} className="p-0">
              <ReusableTabs
                tabs={tabData}
                defaultTab={tab}
                currentTab={(val) => handleTabChange(val)}
                background={'#E4E4E4'}
                color={'#292D32'}
                tabColor={'#A2A2A2'}
                completeColor={'#FFFFFF'}
                boxShadow={'0px 3px 16px 0px #00000014'}
              />
            </Col>
            <Col md={6} lg={7} className="flex justify-end">
              {tab === 1 ? (
                <div
                  className="add-detail"
                  onClick={() => handlePracticeDetail()}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div className="fs-16 family_outfit_medium_500 lh-16 c-C56616 pl-04">
                    Add New Practice
                  </div>
                </div>
              ) : (
                <div
                  className="add-detail"
                  onClick={() => handleSubPracticeModal()}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div className="fs-16 family_outfit_medium_500 lh-16 c-C56616 pl-04">
                    Add New Sub Practice
                  </div>
                </div>
              )}
            </Col>
          </Row>
          {tab === 1 && (
            <div>
              {loading ? (
                <Loader />
              ) : practiceList && practiceList?.length > 0 ? (
                practiceList.map((item, index) => {
                  return (
                    <div className="pt-12">
                      <Row>
                        <Col md={12} className="p-0">
                          <Card className="p-12">
                            <Card.Body className="p-0">
                              <Card.Title>
                                <div className="flex justify-between">
                                  <div className="fs-18 lh-2268 family_outfit_medium_500 fc-202224">
                                    {item?.practice_name}
                                  </div>
                                  <Stack
                                    direction="horizontal"
                                    gap={2}
                                    className="flex items-center cursor-pointer ..."
                                    onClick={() =>
                                      handlePracticeDetail(item?.id)
                                    }
                                  >
                                    <Image src={EditPractice} alt="icon" />
                                    <div className="fs-16 family_outfit_medium_500 fc-A4AAB2 lh-16">
                                      Edit
                                    </div>
                                  </Stack>
                                </div>
                              </Card.Title>
                              <Card.Text>
                                <div className="fs-14 family_outfit_regular_400 pt-04 fc-A4AAB2 lh-176">
                                  {item?.description}
                                </div>
                                <div className="flex justify-between pt-20">
                                  <div className="flex flex-wrap">
                                    {item?.associated_symptoms &&
                                      item?.associated_symptoms?.length > 0 &&
                                      item?.associated_symptoms.map(
                                        (aitem, aindex) => {
                                          return (
                                            <div className="border border border-practice-gray px-32 py-8 rounded-50 mr-10">
                                              <div className="fs-14 family_outfit_regular_400 fc-3C3C3C lh-14">
                                                {aitem?.name}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>
                                  <div>
                                    <Image
                                      src={DeleteList}
                                      alt="icon"
                                      onClick={() =>
                                        handleDeleteModal(item?.id)
                                      }
                                      className="cursor-pointer ..."
                                    />
                                  </div>
                                </div>
                              </Card.Text>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  );
                })
              ) : (
                <div className="flex justify-center pt-120">
                  <div>
                    <Image src={EmptyScreen} alt="icon" />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
                      Nothing here yet practice list
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {tab === 2 && (
            <div>
              {loadingSub ? (
                <Loader />
              ) : subPracticesList && subPracticesList?.length > 0 ? (
                subPracticesList.map((item, index) => {
                  return (
                    <div className="pt-12">
                      <Row>
                        <Col md={12} className="p-0">
                          <Card className="p-12">
                            <Card.Body className="p-0">
                              <Card.Title>
                                <div className="flex justify-between">
                                  <div className="fs-18 lh-2268 family_outfit_medium_500 fc-202224">
                                    {item?.name}
                                  </div>
                                  <Stack
                                    direction="horizontal"
                                    gap={2}
                                    className="flex items-center cursor-pointer ..."
                                    onClick={() =>
                                      handleSubPracticeModal(item?.id, index)
                                    }
                                  >
                                    <Image src={EditPractice} alt="icon" />
                                    <div className="fs-16 family_outfit_medium_500 fc-A4AAB2 lh-16">
                                      Edit
                                    </div>
                                  </Stack>
                                </div>
                              </Card.Title>
                              <Card.Text className="p-0 m-0">
                                <div className="flex justify-between pt-8">
                                  <div>
                                    <div className="fs-14 pt-04 family_outfit_regular_400 fc-A4AAB2 lh-14">
                                      Associated practices:
                                      <span className="fs-14 family_outfit_medium_500 fc-202224 lh-176 pl-04">
                                        {item?.practice?.practice_name}
                                      </span>
                                    </div>
                                  </div>
                                  <div>
                                    <Image
                                      src={DeleteList}
                                      alt="icon"
                                      onClick={() =>
                                        handleDeleteSubModal(item?.id)
                                      }
                                      className="cursor-pointer ..."
                                    />
                                  </div>
                                </div>
                              </Card.Text>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  );
                })
              ) : (
                <div className="flex justify-center pt-120">
                  <div>
                    <Image src={EmptyScreen} alt="icon" />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
                      Nothing here yet practice list
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !deletePracticeLoading && deletePracticeList();
                    }}
                    loading={deletePracticeLoading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'810px'}
        modalActive={SubPracticeModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12} className="p-0">
                <div className="fs-20 fc-292D32 lh-252 family_outfit_semiBold_600">
                  Add a sub-practice
                </div>
              </Col>
              <Col xs={12} className="p-0">
                <div className="pt-24">
                  <LabelWithInput
                    label="Sub-practice Name"
                    placeholder="Sub-practice Name"
                    name="sub_practice_name"
                    type="text"
                    value={formValue?.sub_practice_name}
                    onChange={handleInputChange}
                    errorText={
                      isError &&
                      isError?.sub_practice_name?.error &&
                      isError?.sub_practice_name?.errorMessage
                    }
                  />
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-24">
                  <SelectInput
                    label="Practice Name"
                    placeholder={intl.formatMessage({
                      id: 'Practice Name',
                    })}
                    name={'practiceName'}
                    value={formData?.practice_name}
                    data={providerData}
                    onChange={(e) => handleChange(e, 'practiceName')}
                  />
                </div>
              </Col>
              <Col md={12} className="p-0 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="flex items-center pt-24"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#375241"
                    fontSize="16px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#292D32"
                    fontFamily="outfit_regular"
                    onClick={() => handleCloseSubPracticeModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 49px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#864629"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      (!updateReducer || !createReducer) && handleSubPractice();
                    }}
                    loading={updateReducer || createReducer}
                  >
                    <FormattedMessage id="Create" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteSubModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseSubDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !deleteSubPracticeLoading && deleteSubPracticeList();
                    }}
                    loading={deleteSubPracticeLoading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default PracticeList;
